import '@/common/language.js';
import router from './logRouter';
window.app.modRouter.push(router);
let menuData = sessionStorage.getItem('menuData');
if (menuData) {
    router.mergeRoutes(JSON.parse(menuData), window.vue.$router.options.routes[1].children);
    window.vue.$router.addRoutes(window.vue.$router.options.routes);
}
